module.exports = __webpack_public_path__ + "fonts/subset-mBank-Italic.61b399ac.woff";